import React, { useState } from "react";
import ResizableCell from "../../Utility/ResizableCell";
import { Spinner } from "react-bootstrap";
import { findTitleById } from "../utils";
import CustomTreeSelect from "../../Common/CustomTreeSelect";
import { useGetAllCategories } from "../api";
export default function LaborTable({
  reports,
  handleCategoryChange,
  approveLoading,
  restaurant_id,
}) {
  const [editableCell, setEditableCell] = useState(null);
  const [category, setCategory] = useState(null);
  const [subcategory, setSubcategory] = useState(null);
  const [approveId, setApproveId] = useState(null);
  const { data: categories, isLoading, isError } = useGetAllCategories({
    restaurant_id,
  });
  if (!reports || reports.length === 0) {
    return <p>No reports available</p>;
  }
  const oheaders = Object.keys(reports[0]).filter(
    (key) => key !== "_id" && key !== "pos_id" && key !== "category_bilstm"
  );

  oheaders.push("Approve");

  const desiredOrder = [
    "Job Title",
    "Approve",
    "labor_category",
    "labor_category_confidence",
    "BiLSTM Prediction",
    "Human Verified",
  ];

  // Filter the headers based on the desired order
  const headers = desiredOrder.filter((header) => oheaders.includes(header));

  const handleEditClick = (e, id) => {
    setEditableCell(id);
  };

  const handleEditableCellBlur = (id, cat) => {
    setEditableCell(null);
    handleCategoryChange(id, cat,restaurant_id);
  };
  const handleApprove = (id, category,restaurant_id) => {
    handleCategoryChange(id, category,restaurant_id);
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="table table-striped table-hover table-bordered shadow-sm table-responsive table-stack">
        <thead>
          <tr>
            {headers?.map((header) => (
              <th
                key={header}
                style={{
                  textAlign: "center",
                  textTransform: "capitalize",
                }}
              >
                <ResizableCell>{header.replace(/_/g, " ")}</ResizableCell>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reports?.map((row) => (
            <React.Fragment key={row.item_uuid}>
              <tr>
                {headers?.map((header) => (
                  <td
                    data-label={header.replace(/_/g, " ")}
                    style={{
                      textAlign: "center",
                      textTransform: "capitalize",
                    }}
                    key={header}
                    onClick={(e) => {
                      handleEditClick(e, row._id);
                      setCategory(row.labor_category);
                    }}
                  >
                    {editableCell === row._id && header == "labor_category" ? (
                      <div
                        style={{
                          position: "absolute",
                        }}
                      >
                        <CustomTreeSelect
                          value={findTitleById(
                            categories?.categories.filter(
                              (item) => item.type === "Labor" &&
                              !item?.is_manual
                            ),
                            row[header]
                          )}
                          data={categories?.categories.filter(
                            (item) => item.type === "Labor" && item.title !== "No Employee Type Assigned" &&
                              !item?.is_manual
                          )}
                          placeholder="Select Category"
                          onChange={(item) => {
                            console.log("item", item);
                            handleEditableCellBlur(row._id, item.value,restaurant_id);
                          }}
                        />
                      </div>
                    ) : typeof row[header] === "boolean" ? (
                      row[header] ? (
                        "Yes"
                      ) : (
                        "No"
                      )
                    ) : header == "Approve" ? (
                      approveLoading && approveId === row._id ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          variant="primary"
                        />
                      ) : row["Human Verified"] === true ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="green"
                          class="bi bi-check-circle-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="blue"
                          class="bi bi-hand-thumbs-up-fill"
                          viewBox="0 0 16 16"
                          onClick={() => {
                            setApproveId(row._id);
                            handleApprove(row._id, row.labor_category,restaurant_id);
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                        </svg>
                      )
                    ) : header === "labor_category" ? (
                      <>
                        {findTitleById(
                          categories?.categories.filter(
                            (item) => item.type === "Labor"
                          ),
                          row[header]
                        )}
                      </>
                    ) : header === "BiLSTM Prediction" ? (
                      <>{row[header]}</>
                    ) : (
                      row[header]
                    )}
                  </td>
                ))}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
